module.exports = __webpack_public_path__ + "img/icon-attention.ee71f987.png";